import { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { Theme } from "../../themes/theme";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;
`;

const EyebrowLine = styled.span`
  display: inline-block;
  width: 24px;
  height: 1.5px;
  background: ${Theme.color.text.primary};
  flex-shrink: 0;
`;

const slideFade = keyframes`
  0% {
    opacity: 0;
    transform: translateY(8px);
  }

  15% {
    opacity: 1;
    transform: translateY(0);
  }

  85% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(-8px);
  }
`;

const TextContainer = styled.div`
  position: relative;
  height: auto;
  overflow: hidden;
`;

const EyebrowText = styled.span`
  display: inline-block;
  text-transform: uppercase;
  color: ${Theme.color.text.primary};
  font-size: ${Theme.font.fontSize.sm};
  font-weight: ${Theme.font.fontWeight.medium};
  letter-spacing: ${Theme.font.letterSpacing.wide};

  animation: ${slideFade} 3s ease-in-out;
`;

function RotatingEyebrow({ items = [], duration = 3000 }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (items.length <= 1) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % items.length);
    }, duration);

    return () => clearInterval(interval);
  }, [items, duration]);

  return (
    <Wrapper>
      <EyebrowLine />

      <TextContainer>
        <EyebrowText key={index}>{items[index]}</EyebrowText>
      </TextContainer>
    </Wrapper>
  );
}

export default RotatingEyebrow;
